var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("nav", { attrs: { "aria-label": _vm.ariaLabel } }, [
    _c(
      "ol",
      {
        staticClass: "breadcrumb",
        class: _vm.isInverse ? "ob1-breadcrumb-inverse" : "",
        attrs: { "data-ob1-component": "Breadcrumb" },
      },
      [
        _vm._l(_vm.breadcrumbItems, function (item, index) {
          return _c("li", { key: index, staticClass: "breadcrumb-item" }, [
            _c("a", { attrs: { href: item.href } }, [
              _vm._v(_vm._s(item.label)),
            ]),
          ])
        }),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "breadcrumb-item", attrs: { "aria-current": "page" } },
          [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }